import { defineMessages } from 'react-intl-next';

export default defineMessages({
	reportTableHeading: {
		id: 'spa-apps-servicedesk-reports-home-page.list-view.report-table-heading',
		defaultMessage: 'Title',
		description: 'Table column 1 heading',
	},
	categoruTableHeading: {
		id: 'spa-apps-servicedesk-reports-home-page.list-view.categoru-table-heading',
		defaultMessage: 'Type',
		description: 'Table column 2 heading',
	},
	actionsTableHeading: {
		id: 'spa-apps-servicedesk-reports-home-page.list-view.actions-table-heading',
		defaultMessage: 'Actions',
		description: 'Table column 3 heading',
	},
});
